import { signal } from '@angular/core';
import { FieldTree, SchemaPathTree } from '@angular/forms/signals';
import { SettingsDto } from '../../../core/mceapi.client.generated';

export interface CableSettings {
  disableVoltageFilter: boolean,
  simpleDesignCurrent: boolean
}

export function buildCableSettingsSchema(_: SchemaPathTree<CableSettings>) { }

export function createCableSettings(dto: SettingsDto) {
  const values = dto.values;
  if (values?.disableVoltageFilter === undefined || values.simpleDesignCurrent === undefined) {
    throw new Error('Cable settings DTO is missing required values.');
  }

  return signal<CableSettings>({
    disableVoltageFilter: values.disableVoltageFilter,
    simpleDesignCurrent: values.simpleDesignCurrent
  });
}


export function createCableSettingsDto(model: FieldTree<CableSettings>) {
  return signal<SettingsDto>({
    values: {
      disableVoltageFilter: model.disableVoltageFilter().value(),
      simpleDesignCurrent: model.simpleDesignCurrent().value()
    }
  });
}
